<template>
  <w-modal :value="open" :width="448" @close="close">
    <template #header>
      <h1>
        忘記密碼
      </h1>
    </template>
    <template #content>
      <div>
        <h2 class="has-text-black is-size-6 pb-4">
          請輸入以下資訊，系統將通知帳號擁有者重設密碼。
        </h2>
        <b-field
          :message="getErrorMsgs('identification')"
          :type="{ 'is-danger': hasErrorMsgs('identification') }"
          custom-class="has-text-black"
        >
        <b-input
          :disabled="hasIdentificationParam"
          :use-html5-validation="false"
          v-model="form.identification"
          id="identification-input"
          class="identification-input"
          placeholder="請輸入統一編號"
          type="number"
          @blur="v$.form.identification.$touch"
        />
        </b-field>
        <b-field
          :message="getErrorMsgs('account')"
          :type="{ 'is-danger': hasErrorMsgs('account') }"
        >
          <b-input
            :use-html5-validation="false"
            v-model="form.account"
            placeholder="請輸入登入帳號"
            type="text"
            @blur="v$.form.account.$touch"
          />
        </b-field>
      </div>
    </template>
    <template #footer>
      <div class="flex justify-end w-full">
        <b-button
          :disabled="sending || (v$.form.$invalid && v$.form.$dirty)"
          :loading="sending"
          :outlined="!sending"
          type="is-primary"
          @click="send"
        >
          通知帳號擁有者
        </b-button>
      </div>
    </template>
  </w-modal>
</template>

<script>
import ResetPassword from './ResetPassword';

export default ResetPassword;
</script>

<style lang="scss" scoped>
@import 'ResetPassword';
</style>
